module.exports = __webpack_public_path__ + "img/CapitalOne.19a74920.png";